/**
 * Content type options
 */

import { ContentType } from "../lib/__generated__/graphql";

/**
 * Content filter options type
 */
export type ContentFilter = {
  label: string;
  value: ContentType[];
  param: ContentType | null;
};

/**
 * Content type label map
 */
export const TYPE_LABEL_MAP = {
  [ContentType.Blog]: "Blog",
  [ContentType.Challenge]: "Coding challenge",
  [ContentType.CodebookTopic]: "Codebook",
  [ContentType.Demo]: "Demo",
  [ContentType.Profile]: "Profile",
  [ContentType.Doc]: "Docs",
  [ContentType.DatasetFamily]: "Dataset",
  [ContentType.Webpage]: "Webpage",
  [ContentType.Compilation]: "Compilation",
};

/**
 * All content filter options
 * -----------------------
 * Please note all content types are not included in the list
 * as these features are pending release.
 *
 * The content types are:
 * - Blog
 * - Challenge
 * - CodebookTopic
 * - Demo
 *
 * Profiles are not included at this time to avoid over-saturation of
 * profile results in the search results.
 */
export const CONTENT_FILTERS = [
  {
    label: "All content",
    value: [
      ContentType.Blog,
      ContentType.Challenge,
      ContentType.CodebookTopic,
      ContentType.DatasetFamily,
      ContentType.Demo,
      ContentType.Doc,
      ContentType.Webpage,
      ContentType.Compilation,
    ],
    param: null, // null represents all content
  },
  {
    label: TYPE_LABEL_MAP[ContentType.Blog],
    value: [ContentType.Blog],
    param: ContentType.Blog,
  },
  {
    label: TYPE_LABEL_MAP[ContentType.Challenge],
    value: [ContentType.Challenge],
    param: ContentType.Challenge,
  },
  {
    label: TYPE_LABEL_MAP[ContentType.CodebookTopic],
    value: [ContentType.CodebookTopic],
    param: ContentType.CodebookTopic,
  },
  {
    label: TYPE_LABEL_MAP[ContentType.Demo],
    value: [ContentType.Demo],
    param: ContentType.Demo,
  },
  {
    label: TYPE_LABEL_MAP[ContentType.Profile],
    value: [ContentType.Profile],
    param: ContentType.Profile,
  },
];

/**
 * Default content filter
 */
export const DEFAULT_FILTER = CONTENT_FILTERS[0];
